var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg25(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14645 0.646447C8.34171 0.451184 8.65822 0.451184 8.85348 0.646447C9.04874 0.841709 9.04874 1.15822 8.85348 1.35348L5.20699 4.99996L8.85348 8.64645L8.88798 8.68421C9.04819 8.8806 9.03655 9.17041 8.85348 9.35348C8.67041 9.53655 8.3806 9.54819 8.18421 9.38798L8.14645 9.35348L4.49996 5.70699L0.853478 9.35348C0.658216 9.54874 0.341709 9.54874 0.146447 9.35348C-0.0488155 9.15822 -0.0488155 8.84171 0.146447 8.64645L3.79293 4.99996L0.146447 1.35348C-0.0488155 1.15822 -0.0488155 0.841709 0.146447 0.646447C0.341709 0.451184 0.658216 0.451184 0.853478 0.646447L4.49996 4.29293L8.14645 0.646447Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg25);
export default __webpack_public_path__ + "static/media/svg25.19ca3b0e42bb342354529618b900d60d.svg";
export { ForwardRef as ReactComponent };